import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import axios from "axios";
import HTMLReactParser from "html-react-parser";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index.js";
import "./index.css";

const RigVedQuotes = lazy(() => import("./RigvedQuotes/index.js"));

export default function HeaderNav() {
  const [navbar, setNavbar] = useState(false);
  const [navHidden, setNavHidden] = useState(false);
  const [links, setLinks] = useState({});
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const cdnBucketPath = process.env.REACT_APP_CDN || "";
  const rigvedaQuotePath = `${process.env.REACT_APP_RIGVED_QUOTES_JSON || ""}?v=${Date.now()}`;
  const rigVedQuotesRef = useRef(null);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const brandingJson = process.env.REACT_APP_ANGELAI_JSON;
        if (brandingJson) {
          const res = await axios.get(`${brandingJson}?v=${Date.now()}`);
          setLinks(res.data.current);
        }
      } catch (e) {}
    };
    fetchLinks();
  }, []);

  useEffect(() => {
    let prevScrollPos = window.scrollY;
    const isMobile = () => window.innerWidth < 992;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;

      if (currentScrollPos === 0) {
        setNavbar(false);
        setNavHidden(false);
      } else {
        setNavbar(true);
        if (isMobile()) {
          if (prevScrollPos > currentScrollPos) {
            setNavHidden(false);
          } else {
            setNavHidden(true);
          }
        } else {
          setNavHidden(false);
        }
      }

      prevScrollPos = currentScrollPos;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (rigVedQuotesRef.current && !rigVedQuotesRef.current.contains(e.target)) {
        setShowRigVedQuotes(false);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <Navbar
      id="angelaiNavbar"
      fixed="top"
      variant="dark"
      className={`navbar ${navbar ? "active" : ""} ${navHidden ? "navbarTransition" : ""}`}
    >
      <Container className="navbar-container">
        <Navbar.Brand>
          <div className="position-relative">
            <div className="logo-margin">
              <a href="https://www.angelai.com" target="_self">
                 <img
                  src={`${process.env.REACT_APP_ANGELAI_IMAGES}latest-angelai-logo.webp`}
                  alt="AngelAi Logo"
                  className="angelai-icon-logo"
                  fetchpriority="high"
                /> 
              </a>
            </div>
            <div className="logo-margin brandTagLineBox" ref={rigVedQuotesRef}>
              <div>
                <div
                  className="brandTagLineContainer brand-tagline-black"
                  onMouseEnter={() => setShowRigVedQuotes(true)}
                  onMouseLeave={() => setShowRigVedQuotes(false)}
                  onClick={() => setShowRigVedQuotes(!showRigVedQuotes)}
                >
                  <p className="brandTagLine">
                    {links.brandTagLine
                      ? HTMLReactParser(String(links.brandTagLine))
                      : ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Navbar.Brand>
        <Suspense fallback={null}>
          <RigVedQuotes
            rigvedaQuotePath={rigvedaQuotePath}
            showRigVedQuotes={showRigVedQuotes}
            closeRigved={() => setShowRigVedQuotes(false)}
          />
        </Suspense>
        <div className="desktopaccesibility">
          <a href="https://www.mindsetsummit.com/" target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.REACT_APP_IMAGES}mindset-logo.svg`}
              alt="Mindset Summit Logo"
              className="logo-image"
              fetchpriority="high"
            />
          </a>

          <UserWayAccessibilityMenu color="white" width={35} height={35} cdnPath={cdnBucketPath} />
        </div>
      </Container>
    </Navbar>
  );
}
